import * as Dialog from '@radix-ui/react-dialog';
import { forwardRef } from 'react';

import { Button, type ButtonProps } from '../../../server/Button/Button';

export type ModalCloseProps = ButtonProps;

export const ModalClose = forwardRef<HTMLButtonElement, ModalCloseProps>((props, ref) => {
	return (
		<Dialog.Close asChild>
			<Button ref={ref} {...props} />
		</Dialog.Close>
	);
});
